<template>
  <div class="multi-account-component">
    <div v-if="selectedEtab" class="multi-account-selected-etab">
      <h4>{{ $t('ETAB.PAGES.MULTI_ACCOUNT.@CONNECTED_AS') }}</h4>
      <QCard class="multi-account-cards">
        <QImg :src="selectedEtab.getPicture() || getPlaceHolder" :alt="selectedEtab.getName()" style="height: 150px; ">
          <div class="absolute-bottom card-btn" style="padding:0;">
            <QBtn
              class="full-width"
              align="right"
              type="a"
              :label="selectedEtab.getName()"
              :icon-right="`icon-extra-check`"
            />
          </div>
        </QImg>
      </QCard>
    </div>
    <div class="multi-account-selected-others-etabs">
      <h4>
        {{ displayEtabListTitle }}
      </h4>
      <div
        v-for="etablissement in availableEtablissements"
        :key="etablissement.getId()"
      >
        <QCard class="multi-account-cards">
          <QImg :src="etablissement.getPicture() || getPlaceHolder" :alt="etablissement.getName()" style="height: 150px; ">
            <div class="absolute-bottom card-btn" style="padding:0;">
              <QBtn
                class="full-width"
                align="right"
                type="a"
                :label="etablissement.getName()"
                :icon-right="`icon-f-arrow-right`"
                @click="selectedEtabToSupervised(etablissement)"
              />
            </div>
          </QImg>
        </QCard>
      </div>
    </div>
  </div>
</template>

<script>
import { MultiAccountManager } from "@etab/managers/multi-account.manager";
import { UserStorageManager } from "@core/managers/user-storage.manager";
import { JavascriptHelpers } from "@core/helpers";
import placeholder from "@core/assets/img/logos/logo_extra_candidat.png";
import { MultiAccountEtabModel } from "@core/models";

export default {
  props: {
    availableEtablissements: {
      type: Array,
      default: () => [],
    },
    selectedEtab: {
      type: Object,
      default: () => new MultiAccountEtabModel(),
    },
  },
  computed: {
    getPlaceHolder() {
      return placeholder;
    },
    displayEtabListTitle() {
      return this.selectedEtab ? this.$t("ETAB.PAGES.MULTI_ACCOUNT.@OTHER_ETAB") : this.$t("ETAB.PAGES.MULTI_ACCOUNT.@ETABLISSEMENTS");
    },
  },
  methods: {
    async selectedEtabToSupervised(etablissement) {
      try {
        this.$_startGlobalLoading();
        const selectedEtabId = etablissement.getId();
        const hasSupervisedEtab = await UserStorageManager.getSupervisorData();
        if (hasSupervisedEtab) {
          MultiAccountManager.stopSupervisorMode();
        }
        await MultiAccountManager.initSupervisorMode(selectedEtabId);
      } catch (error) {
        throw error;
      } finally {
        JavascriptHelpers.reloadWindow();
        this.$_stopGlobalLoading();
      }
    },
  },
};
</script>

<style lang="scss">
.multi-account-component {
  h4 {
    margin-left: 50px;
  }
  .multi-account-cards {
    width: 80%;
    margin: 20px auto 10px;
  }
  .multi-account-selected-etab,
  .multi-account-selected-others-etabs {
    margin-top: 30px;
    > .card-btn {
      box-shadow: $card-shadow;
    }
  }
}
</style>
